export default __webpack_public_path__ + "static/media/ed2.0ed8e77f.jpg";